import * as NOTIFICATION from './modal-confirm-notification';

export const notification = {
  route_conflicts: NOTIFICATION.CONFLICT_ROUTE,
  route_priorities: NOTIFICATION.PRIORITIES_ROUTE,
  delete_zone: NOTIFICATION.DELETE_ZONE,
  deleteItem: NOTIFICATION.DELETE_ITEM,
  save: NOTIFICATION.SAVE,
  exit: NOTIFICATION.EXIT,
  clean: NOTIFICATION.CLEAN,
  deleteProduct: NOTIFICATION.DELETE_PRODUCT,
  cancelPay: NOTIFICATION.CANCEL_PAY,
  orderPayment: NOTIFICATION.ORDER_PAYMENT,
  deleteLocationsInStore: NOTIFICATION.DELETE_ITEM,
  cancelSKUDispatch: NOTIFICATION.CANCEL_SKU_DISPATCH_NOTIFICATION,
  printSuccessDispatch: NOTIFICATION.PRINT_SUCCESS_DISPATCH_NOTIFICATION,
  alertItem: NOTIFICATION.ALERT_ITEM,
  upload_registers_info: NOTIFICATION.UPLOAD_REGISTER_INFO, // eliminar
  deleteQuote: NOTIFICATION.DELETE_QUOTE,
  cancelSKUOrderPicking: NOTIFICATION.CANCEL_SKU_ORDER_PICKING_NOTIFICATION,
  cancelQuotation: NOTIFICATION.CANCEL_QUOTATION,
  saveQuotation: NOTIFICATION.SAVE_QUOTATION,
  finallyQuotation: NOTIFICATION.EMIT_QUOTATION,
  deleteApprovalRange: NOTIFICATION.DELETE_APPROVAL_RANGE,
  approveQuotation: NOTIFICATION.SAVE_QUOTATION,
  copyQuotation: NOTIFICATION.COPY_QUOTATION,
  skuDuplicate: NOTIFICATION.SKU_DUPLICATE,
  cancelCurrentQuotatation: NOTIFICATION.CANCEL_CURRENT_QUOTATION,
  deleteServiceAdditional: NOTIFICATION.DELETE_SERVICES_ADDITIONAL,
  sessionExpired : NOTIFICATION.SESSION_EXPIRED,
  CREDIT_NONE: NOTIFICATION.CREDIT_NONE,
  applyGeneralDiscount: NOTIFICATION.APPLY_GENERAL_DISCOUNT,
  applyGeneralMargen: NOTIFICATION.APPLY_GENERAL_MARGEN,
  notMeasureProduct : NOTIFICATION.REDIRECT_CREATE_QUOTATION,
  updateQuotattion: NOTIFICATION.UPDATE_DELIVERY,
  notSaleService: NOTIFICATION.REDIRECT_CREATE_SERVICE,
  deleteShipping: NOTIFICATION.DELETE_SHIPING,
  routeDisabled: NOTIFICATION.DISABLE_ROUTE,
  routeReturn: NOTIFICATION.RETURN_ROUTE,
  deleteHolidayException: NOTIFICATION.DELETE_HOLIDAY_EXCEPTION
};
